module.exports = __webpack_public_path__ + "6c7c9995576248f481fa568f8f72621a.pdf";